import React from "react";
// outsource
import { Row, Col, Button, Input } from "antd";
import { DownloadOutlined, SearchOutlined, SyncOutlined, UploadOutlined } from "@ant-design/icons";

const PayrateBonusToolbar = ({
  keyword,
  setKeyword,
  setPage,
  onDownload,
  onOpenImport,
  onRecalculate,
  recalculating,
}) => {
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row className="payrate-bonus-toolbar" align="middle" gutter={[12, 12]} style={{ marginBottom: 22 }}>
        <Col flex="auto">
          <Row align="middle" gutter={[12, 12]}>
            <Col>
              <Input
                className="payrate-bonus-search"
                prefix={<SearchOutlined />}
                placeholder="Enter Name to search"
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                  setPage(1);
                }}
              />
            </Col>
            <Col>
              <Button type="primary" icon={<DownloadOutlined />} onClick={onDownload}>
                Download
              </Button>
            </Col>
            <Col>
              <Button type="primary" icon={<UploadOutlined />} onClick={onOpenImport}>
                Import csv
              </Button>
            </Col>
          </Row>
        </Col>
        <Col>
          <Button
            type="primary"
            icon={<SyncOutlined spin={recalculating} />}
            disabled={recalculating}
            onClick={onRecalculate}
          >
            Recalculate
          </Button>
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------
  return renderBody();
};

export default PayrateBonusToolbar;
